/* Product page restyle — gestione altezza dei tab (autoHeight) + box vuoto.
   La card dei tab si adatta all'altezza del tab ATTIVO, eliminando lo spazio
   sopra/sotto causato dallo Swiper (che teneva l'altezza del tab più alto). */
(function () {
  function hasContent(el) {
    if (!el) return false;
    if (el.querySelector('img, svg, ul, ol, table, iframe, picture')) return true;
    return el.textContent.replace(/ /g, ' ').trim().length > 0;
  }

  function setup(pt) {
    var card = pt.querySelector('.tab-wrap-content');
    if (!card) return;
    var wrapper = card.querySelector('.swiper-wrapper');

    function activeContent() {
      var slide = card.querySelector('.swiper-slide-active');
      return (slide && slide.querySelector('.tab-content'))
        || card.querySelector('.tab-content.active')
        || card.querySelector('.tab-content');
    }

    // Sincronizza l'indicatore della nav col tab realmente selezionato (per INDICE,
    // perché le classi swiper-slide-active/thumb-active della nav non sono affidabili).
    function syncNav() {
      var nav = pt.querySelector('.tab-wrap-nav');
      if (!nav) return;
      var contentSlides = card.querySelectorAll('.swiper-wrapper > .swiper-slide');
      var navSlides = nav.querySelectorAll('.swiper-wrapper > .swiper-slide');
      var activeIdx = -1;
      contentSlides.forEach(function (s, i) {
        if (s.classList.contains('swiper-slide-active')) activeIdx = i;
      });
      navSlides.forEach(function (s, i) {
        s.classList.toggle('is-active-tab', i === activeIdx);
      });
    }

    function update() {
      var a = activeContent();
      var empty = !hasContent(a);
      card.classList.toggle('is-empty', empty);
      if (wrapper) wrapper.style.height = (empty || !a) ? '0px' : (a.scrollHeight + 'px');
      syncNav();
    }

    // Avvolge il testo dei nav tab in <span> per l'indicatore ::after
    var nav = pt.querySelector('.tab-wrap-nav');
    if (nav) {
      nav.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach(function (slide) {
        if (!slide.querySelector('span')) {
          slide.innerHTML = '<span>' + slide.textContent + '</span>';
        }
      });
    }

    // primo calcolo + ricontrolli (font/immagini che caricano)
    update();
    [120, 400, 900].forEach(function (t) { setTimeout(update, t); });

    pt.querySelectorAll('.tab-wrap-nav .swiper-slide').forEach(function (t) {
      t.addEventListener('click', function () { setTimeout(update, 60); setTimeout(update, 420); });
    });

    // osserva SOLO il cambio di classe (.active si sposta) — non lo style, per evitare loop
    if ('MutationObserver' in window) {
      new MutationObserver(update).observe(card, {
        attributes: true, subtree: true, attributeFilter: ['class']
      });
    }
    window.addEventListener('resize', function () { setTimeout(update, 120); });
    window.addEventListener('load', update);
  }

  function init() { document.querySelectorAll('product-tabs').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Rimuove il focus dai bottoni quantità dopo il click (evita che rimangano colorati)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.prd-quantity-btn')) e.target.closest('.prd-quantity-btn').blur();
  });
})();
